/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedAuditLogEntrySchema } from '../models/PagedAuditLogEntrySchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuditApi {
    /**
     * Get Audit Log
     * Get audit log of company.
     * @returns PagedAuditLogEntrySchema OK
     * @throws ApiError
     */
    public static auditGetAuditLogGet({
        search,
        dateFrom,
        dateTo,
        userId,
        action,
        modelType,
        limit = 100,
        offset,
    }: {
        search?: (string | null),
        dateFrom?: (string | null),
        dateTo?: (string | null),
        userId?: Array<string>,
        action?: Array<'CREATE' | 'UPDATE' | 'ARCHIVE' | 'DELETE'>,
        modelType?: Array<'VISIT' | 'PATIENT' | 'RECEIPT' | 'GROUP_VISIT' | 'INSURANCE_ACTION_TEMPLATE' | 'TEMPLATE' | 'ROOM' | 'LOCATION' | 'USER'>,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedAuditLogEntrySchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/audit/',
            query: {
                'search': search,
                'date_from': dateFrom,
                'date_to': dateTo,
                'user_id': userId,
                'action': action,
                'model_type': modelType,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Audit Log Export
     * Create audit log export. <br>Required Permission: list_audit_log
     * @returns any OK
     * @throws ApiError
     */
    public static auditGetAuditLogExportGet({
        search,
        dateFrom,
        dateTo,
        userId,
        action,
        modelType,
    }: {
        search?: (string | null),
        dateFrom?: (string | null),
        dateTo?: (string | null),
        userId?: Array<string>,
        action?: Array<'CREATE' | 'UPDATE' | 'ARCHIVE' | 'DELETE'>,
        modelType?: Array<'VISIT' | 'PATIENT' | 'RECEIPT' | 'GROUP_VISIT' | 'INSURANCE_ACTION_TEMPLATE' | 'TEMPLATE' | 'ROOM' | 'LOCATION' | 'USER'>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/audit/export',
            query: {
                'search': search,
                'date_from': dateFrom,
                'date_to': dateTo,
                'user_id': userId,
                'action': action,
                'model_type': modelType,
            },
        });
    }
}
